import { useState } from 'react';
import { Link } from 'react-router-dom';
import { rankings } from '@/mocks/anime';

const trendIcon: Record<string, string> = {
  up: 'ri-arrow-up-line',
  down: 'ri-arrow-down-line',
  same: 'ri-subtract-line',
};

const trendColor: Record<string, string> = {
  up: 'text-green-600',
  down: 'text-red-500',
  same: 'text-foreground-500',
};

export default function Ranking() {
  const [tab, setTab] = useState<'weekly' | 'monthly'>('weekly');
  const list = rankings[tab];

  return (
    <section className="py-10 md:py-14 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-2">
            排行榜
          </h2>
          <p className="text-foreground-600 text-sm">热门动漫人气排行</p>
        </div>

        <div className="flex justify-center mb-8">
          <div className="inline-flex bg-background-200 rounded-full px-1 py-1">
            <button
              onClick={() => setTab('weekly')}
              className={`px-6 py-2 rounded-full text-sm font-medium transition-all cursor-pointer whitespace-nowrap ${
                tab === 'weekly'
                  ? 'bg-background-50 text-foreground-950'
                  : 'text-foreground-600 hover:text-foreground-900'
              }`}
            >
              周排行
            </button>
            <button
              onClick={() => setTab('monthly')}
              className={`px-6 py-2 rounded-full text-sm font-medium transition-all cursor-pointer whitespace-nowrap ${
                tab === 'monthly'
                  ? 'bg-background-50 text-foreground-950'
                  : 'text-foreground-600 hover:text-foreground-900'
              }`}
            >
              月排行
            </button>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-1 gap-3 max-w-2xl mx-auto">
          {list.map((item) => (
            <Link
              key={item.rank}
              to={`/article/${item.slug}`}
              className="flex items-center gap-4 px-4 py-3 rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-200 hover:bg-primary-50/30 transition-all duration-200 cursor-pointer"
            >
              <div className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold flex-shrink-0 ${
                item.rank === 1
                  ? 'bg-accent-500 text-background-50'
                  : item.rank === 2
                    ? 'bg-secondary-500 text-background-50'
                    : item.rank === 3
                      ? 'bg-primary-400 text-background-50'
                      : 'bg-background-200 text-foreground-600'
              }`}>
                {item.rank}
              </div>
              <span className="flex-1 text-foreground-950 font-medium text-sm md:text-base truncate">
                {item.title}
              </span>
              <span className="text-accent-600 font-semibold text-sm">{item.score}</span>
              <span className={`text-sm ${trendColor[item.trend]}`}>
                <i className={trendIcon[item.trend]}></i>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}